"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IlStudentHeader = void 0;
var material_1 = require("@mui/material");
var il_default_avatar_1 = require("../il-student-card/il-default-avatar");
var react_1 = __importDefault(require("react"));
var typeography_common_1 = require("../typeography/typeography.common");
var user_config_1 = require("../../configs/user.config");
var IlStudentHeader = function (props) {
    return (react_1.default.createElement(material_1.Box, { className: 'il-student-header ' + props.className, sx: __assign({ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }, props.sx) },
        react_1.default.createElement(material_1.Box, { sx: {
                display: 'flex',
                flexDirection: 'row',
                gap: '0.5rem',
                alignItems: 'center',
            } },
            props.avatar && (react_1.default.createElement(material_1.Avatar, { sx: { height: '3rem', width: '3rem' } },
                react_1.default.createElement(il_default_avatar_1.ILDefaultAvatar, { color: (props.avatar && user_config_1.userConfig.color[props.avatar]) || props.avatar }))),
            react_1.default.createElement(material_1.Box, null,
                props.name && (react_1.default.createElement(typeography_common_1.ILSubtitle1, { sx: {
                        lineHeight: 1,
                        fontSize: { xs: '1rem', sm: '1.125rem' },
                    } }, props.name)),
                props.assignmentsText && (react_1.default.createElement(typeography_common_1.ILCaption, { sx: {
                        color: 'text.secondary',
                        fontSize: { xs: '0.70rem', sm: '0.75rem' },
                        lineHeight: { xs: '0.70rem', sm: '0.75rem' },
                    } },
                    props.assignmentsNumber,
                    " ",
                    props.assignmentsText)))),
        react_1.default.createElement(material_1.Box, { sx: { display: 'flex', gap: '0.5rem', alignItems: 'center' } },
            props.overdueText && (react_1.default.createElement(typeography_common_1.ILCaption, { sx: {
                    color: 'error.main',
                } },
                props.overdueNumber,
                " ",
                props.overdueText)),
            props.children)));
};
exports.IlStudentHeader = IlStudentHeader;
